import gsap from 'gsap'

const setupAccordion = (el) => {
  const triggers = el.querySelectorAll('[data-trigger]')
  const content = el.querySelector('[data-content]')
  const plus = el.querySelector('[data-plus]')
  const minus = el.querySelector('[data-minus]')

  let isOpen = false

  function open() {
    window.requestAnimationFrame(() => {
      content.style.maxHeight = 'inherit'
      const height = content.getBoundingClientRect().height

      content.style.maxHeight = 0

      window.requestAnimationFrame(() => {
        gsap
          .timeline()
          .fromTo(
            content,
            {
              opacity: 0,
              y: 30,
            },
            {
              maxHeight: height,
              opacity: 1,
              y: 0,
              duration: 0.6,
              ease: 'expo.inOut',
              onStart: () => {
                isOpen = true
              },
            },
          )
          .to(
            plus,
            {
              opacity: 0,
              rotate: '-90deg',
              duration: 0.6,
              ease: 'expo.inOut',
            },
            0,
          )
          .fromTo(
            minus,
            {
              rotate: '90deg',
            },
            {
              opacity: 1,
              rotate: 0,
              duration: 0.6,
              ease: 'expo.inOut',
            },
            0,
          )
          .eventCallback('onComplete', () => {
            gsap.set(content, {
              maxHeight: 'min-content',
            })
          })
      })
    })
  }

  function close() {
    window.requestAnimationFrame(() => {
      const height = content.getBoundingClientRect().height

      content.style.maxHeight = `${height}px`

      window.requestAnimationFrame(() => {
        gsap
          .timeline()
          .to(content, {
            maxHeight: 0,
            opacity: 0,
            y: 30,
            duration: 0.6,
            ease: 'expo.inOut',
            onStart: () => {
              isOpen = false
            },
          })
          .to(
            plus,
            {
              opacity: 1,
              rotate: 0,
              duration: 0.6,
              ease: 'expo.inOut',
            },
            0,
          )
          .fromTo(
            minus,
            {
              rotate: 0,
            },
            {
              opacity: 0,
              rotate: '90deg',
              duration: 0.6,
              ease: 'expo.inOut',
            },
            0,
          )
          .eventCallback('onComplete', () => {
            gsap.set(content, {
              clearProps: 'all',
            })
          })
      })
    })
  }

  function toggle() {
    if (isOpen) {
      close()
    } else {
      open()
    }
  }

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', toggle, false)
  })
}

export default setupAccordion
